import { render, staticRenderFns } from "./operator.vue?vue&type=template&id=08b10885&scoped=true&"
import script from "./operator.vue?vue&type=script&lang=js&"
export * from "./operator.vue?vue&type=script&lang=js&"
import style0 from "./operator.vue?vue&type=style&index=0&id=08b10885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b10885",
  null
  
)

export default component.exports